import script from "./Panel.vue?vue&type=script&setup=true&lang=js"
export * from "./Panel.vue?vue&type=script&setup=true&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=88c2b738&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88c2b738"]])

export default __exports__